import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory({ basename: window.REACT_APP_HISTORY_BASE });
